import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import constant from '../../constant';
import { Mail, Lock } from 'lucide-react';
import ChangePassword from './changePassword';

const Login = () => {
  const [mail, setMail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!mail || !password) {
      setError('Please enter both email and password.');
      return;
    }

    setIsLoading(true);
    setError('');

    try {
      const response = await fetch(`${constant.REACT_APP_API_URL}/auth/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email: mail, password: password }),
      });

      const data = await response.json();

      if (response.ok) {
        localStorage.setItem('token', data.access_token);
        localStorage.setItem('role', data.user.role);
        localStorage.setItem('loggedInUser', data.user.name);
        localStorage.setItem('hospitalId', data.user.hospital_id);
        localStorage.setItem('hospitalLogo', data.user.hospital_logo);
        localStorage.setItem('userId', data.user.id);
        localStorage.setItem('is_first_login', data.user.is_first_login);
        localStorage.setItem('hospitalName', data.user.hospital_name);

        if (data.user.is_first_login) {
          navigate('/changePassword');
        }

        navigate('/dashboard');
        window.dispatchEvent(new Event('storage'));
      } else {
        setError(data.message || 'Login failed');
      }
    } catch (error) {
      setError('An error occurred. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-r from-[#8A2BE2] to-[#40E0D0]">

      <div className="text-center mb-8">
        <h2 className="text-5xl font-bold text-white mb-2">Welcome to <span className="text-5xl font-bold text-white mb-2">Riqaba Innovations</span></h2>
      </div>

      <div className="w-full flex justify-center md:px-12 px-4"> {/* Container to align form to the right */}
        <div className="bg-none md:p-10 p-8 rounded-xl shadow-2xl w-full max-w-md backdrop-blur-sm bg-opacity-95 border border-gray-700"> {/* Enhanced card with increased width */}
          <div className="flex justify-center mb-8">
            <img src="/riqaba-logo.png" alt="Riqaba Innovations Logo" className="h-24 w-auto" />
          </div>

          {error && <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded-lg mb-6" role="alert">
            <strong className="font-bold">Error!</strong>
            <span className="block sm:inline ml-1">{error}</span>
          </div>}

          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label htmlFor="mail" className="block text-sm font-medium text-gray-300 mb-2">
                Email
              </label>
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <Mail className="h-5 w-5 text-gray-400" />
                </div>
                <input
                  id="mail"
                  type="email"
                  value={mail}
                  onChange={(e) => setMail(e.target.value)}
                  className="block w-full pl-10 pr-3 py-3 border border-gray-700 rounded-lg focus:ring-blue-500 focus:border-blue-500 shadow-sm"
                  placeholder="Your email address"
                  required
                />
              </div>
            </div>

            <div>
              <label htmlFor="password" className="block text-sm font-medium text-gray-300 mb-2">
                Password
              </label>
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <Lock className="h-5 w-5 text-gray-400" />
                </div>
                <input
                  id="password"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="block w-full pl-10 pr-3 py-3 border border-gray-700 rounded-lg focus:ring-blue-500 focus:border-blue-500 shadow-sm"
                  placeholder="Your password"
                  required
                />
              </div>
            </div>

            <div className="pt-2">
              <button
                type="submit"
                className={`w-full flex justify-center py-3 px-4 border border-transparent rounded-lg shadow-md text-base font-medium text-white ${isLoading ? 'brand-blue cursor-wait' : 'brand-blue hover:bg-blue-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500'}`}
                disabled={isLoading}
              >
                {isLoading ? (
                  <>
                    <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    Logging in...
                  </>
                ) : 'Log in'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;